import { useLocation } from 'react-router-dom'
import styled from 'styled-components'

import Instagram from '~/shared/assets/icons/Instagram'
import Twitter from '~/shared/assets/icons/Twitter'
import ASound from '~/shared/assets/logos/asound-logo.png'
import VerticalLogo from '~/shared/assets/logos/illustar-logo-vertical-eng.svg'
import IllustarfesLogo from '~/shared/assets/logos/IllustarfesLogo'
import Samhyun from '~/shared/assets/logos/samhyun-logo.png'
import SinaliumLogo from '~/shared/assets/logos/sinalium-logo.png'
import Sinosabi from '~/shared/assets/logos/sinosabi-logo.png'
import Starlike from '~/shared/assets/logos/starlike-logo.png'
import theme from '~/shared/styles/theme'

function Footer() {
  const location = useLocation()
  const pathname = location.pathname

  return (
    <>
      <Wrapper>
        <Logo src={VerticalLogo} alt="logo" />
        <Container>
          <BizInfoBox>
            <span>법인명(단체명): 스타라이크 주식회사</span>
            <span>대표자: 채병효</span>
            <span>사업자 등록번호: 299-81-02494</span>
            <span>
              주소: 전북특별자치도 전주시 덕진구 오공로 123, 9층 908호(만성동,
              전북테크비즈센터)
            </span>
            <span>전화번호: 070-8287-2271</span>
            <a href={`${import.meta.env.VITE_REDIRECT_URI}terms`}>
              이용약관 및 개인정보 처리 방침
            </a>
            {/*  */}
          </BizInfoBox>
        </Container>
        <SNSBox>
          <Instagram
            onClick={() =>
              window.open('https://www.instagram.com/illustar_fes', '_blank')
            }
          />
          <Twitter
            onClick={() =>
              window.open('https://twitter.com/illustar_fes', '_blank')
            }
          />
        </SNSBox>
      </Wrapper>
      <CooperationContainer $pathname={pathname}>
        <CooperationBox>© 2024 illustarfes</CooperationBox>

        <CooperationBox>
          <span>주최</span>
          <IllustarfesLogo />
        </CooperationBox>
        <CooperationBox>
          <span>주관</span>
          <img
            className="logo"
            src={Starlike}
            alt="starlike"
            width={110}
            height={36}
          />
          <img
            className="logo"
            src={SinaliumLogo}
            alt="sinalium"
            width={108}
            height={36}
          />
        </CooperationBox>

        {/* <div className="divider" /> */}
        <CooperationBox>
          <span>협력</span>

          <img
            className="logo"
            src={Sinosabi}
            alt="sinosabi"
            width={117}
            height={36}
          />
          <img
            className="logo"
            src={ASound}
            alt="aSound"
            width={72}
            height={36}
          />
          <img
            className="logo"
            src={Samhyun}
            alt="samhyun"
            width={117}
            height={36}
          />
        </CooperationBox>
      </CooperationContainer>
    </>
  )
}

export default Footer

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: center;

  height: auto;
  margin: 40px 0;
`

const Logo = styled.img`
  width: 95px;
  height: 120px;
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const BizInfoBox = styled.div`
  display: flex;
  flex-flow: column;
  gap: 20px;

  box-sizing: border-box;
  width: 100%;
  padding: 20px;

  text-align: center;

  a {
    color: ${theme.colors.grey_5};
    text-decoration: underline;
  }
`

const SNSBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  align-items: center;

  @media ${theme.device.medium} {
    gap: 10px;
  }
`

const CooperationContainer = styled.div<{ $pathname: string }>`
  display: flex;
  flex-wrap: wrap;
  gap: 36px;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;
  width: 100%;
  height: auto;
  padding: 40px;

  color: ${theme.colors.grey_1};

  background-color: ${theme.colors.grey_5};

  .divider {
    width: 1px;
    height: 20%;
    background-color: ${theme.colors.grey_3};

    @media ${theme.device.medium} {
      width: 20%;
      height: 1px;
    }
  }

  @media ${theme.device.medium} {
    flex-direction: column;
  }
`

const CooperationBox = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;

  @media ${theme.device.medium} {
    flex-direction: column;
  }
`
